import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import thunk from 'redux-thunk';
import { browserHistory } from 'react-router/lib/browserHistory';
import { routerMiddleware } from 'react-router-redux';
import { DEV_ENV, DISABLE_LOGS } from '../constants/env';
import createReducer from './reducers';
import saga from './sagas';

const routingMiddleware = routerMiddleware(browserHistory);
const sagaMiddleware = createSagaMiddleware();
const middlewares = [thunk, sagaMiddleware, routingMiddleware];
const composeEnhancers =
  (DEV_ENV && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

export const runRootSaga = store => {
  sagaMiddleware.run(saga, { dispatch: store.dispatch });
};

const create = (state = {}) => {
  if (DEV_ENV) {
    /* eslint-disable global-require, import/no-extraneous-dependencies */
    const createLogger = require('redux-logger');
    /* eslint-enable global-require, import/no-extraneous-dependencies */
    const logger = createLogger({
      level: 'info',
      duration: true,
      collapsed: true,
      diff: true,
    });
    if (!DISABLE_LOGS) {
      middlewares.push(logger);
    }
  }

  const store = createStore(
    createReducer(),
    state,
    composeEnhancers(applyMiddleware(...middlewares)),
  );

  store.runSaga = sagaMiddleware.run;
  store.injectedReducers = {}; // Reducer registry
  store.injectedSagas = {}; // Sag

  return store;
};

export default create;



// WEBPACK FOOTER //
// ./src/redux/store.js